export enum BotMergeDestinationState {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
}
